import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BuildingInsights3"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 1.5H7.5V5.25H9V1.5ZM15 6H13.5V7.5H15V6ZM19.5 6H18V7.5H19.5V6ZM13.5 10.5H15V12H13.5V10.5ZM19.5 10.5H18V12H19.5V10.5ZM13.5 15H15V16.5H13.5V15ZM19.5 15H18V16.5H19.5V15ZM1.5 7.5H5.25V9H1.5V7.5ZM3 4.0605L4.0605 3L6.75 5.68875L5.68875 6.75L3 4.0605ZM12 1.5H21C21.8281 1.50083 22.4992 2.17192 22.5 3V22.5H1.5V12C1.50083 11.1719 2.17192 10.5008 3 10.5H10.5V3C10.5008 2.17192 11.1719 1.50083 12 1.5ZM6.75 21V15.75H9.75V21H6.75ZM11.25 21H21V3H12V12H3V21H5.25V15C5.25 14.5858 5.58579 14.25 6 14.25H10.5C10.9142 14.25 11.25 14.5858 11.25 15V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BuildingInsights3.vue"]]);
